import Head from 'next/head'

import type { FC, ReactNode } from 'react'
import type { SeoProps } from '@/types'

import { useRouter } from 'next/router'
import { siteConfig } from '@/constants/site'

export const Seo: FC<SeoProps> = ({
    title,
    description = siteConfig.description,
    ogImage
}): ReactNode => {
    const { asPath } = useRouter()
    const pageTitle = title ? `${title} - ${siteConfig.name}` : siteConfig.name
    const path = asPath.split(/[?#]/)[0]
    const pageUrl = `${siteConfig.url}${path === '/' ? '' : path}`

    return (
        <Head>
            <title>
                {pageTitle}
            </title>

            <meta name='description' content={description} />
            <link rel='canonical' href={pageUrl} />
            <meta property='og:site_name' content={siteConfig.name} />
            <meta property='og:title' content={pageTitle} />
            <meta property='og:description' content={description} />
            <meta property='og:type' content='website' />
            <meta property='og:url' content={pageUrl} />
            <meta name='twitter:card' content='summary_large_image' />
            <meta name='twitter:title' content={pageTitle} />
            <meta name='twitter:description' content={description} />

            {ogImage && <meta property='og:image' content={ogImage} />}
            {ogImage && <meta name='twitter:image' content={ogImage} />}
        </Head>
    )
}
